import Network from '@/services/network'

export default function handleOnlinePayment() {
    const network = new Network();

    const initiatePayment = (data) => {
        return network.api('POST', 'online-payment/initiate', data);
    }

    return {
        initiatePayment
    }
}
